stateProviders.push({
    name: "root",
    url: "",
    templateUrl: "fast/submodules/login/partials/login.html?v=" + versionNo,
    controller: "LoginController",
    resolve: {
        easyLog: function($http, $location) {
            let ismToken = "";
            if ($location.$$absUrl.indexOf("?") !== -1) {
                ismToken = $location.$$absUrl.split("?")[1].split("=")[1];
                let headers = {headers: {ismToken: ismToken}};
                return $http.get("/api/easyLog", headers);
            }
        }
    }
});

stateProviders.push({
    name: "login",
    url: "/login",
    templateUrl: "fast/submodules/login/partials/login.html?v=" + versionNo,
    controller: "LoginController",
});

stateProviders.push({
    name: "forgot",
    url: "/forgot",
    templateUrl: "fast/submodules/login/partials/forgot.html?v=" + versionNo,
    controller: "ForgotPasswordController"
});

stateProviders.push({
    name: "reset",
    url: "/reset",
    templateUrl: "fast/submodules/login/partials/reset.html?v=" + versionNo,
    controller: "ResetPasswordController"
});
